<ng-container
  *ngIf="formGroup && formGroup.isDirtyAndTouched && formGroup.hasErrors">
  <small *ngFor="let message of formGroup.messages()" class="text-danger"
    [innerHTML]="message.msg | transloco:message.vars">
  </small>
</ng-container>